// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"204":"system","669":"items","709":"order","962":"home","966":"login"}[chunkId] || chunkId) + "." + {"204":"b667049b","265":"c3504ccc","624":"6873f58a","669":"07273aac","696":"6cc0eaad","709":"2883eeb8","772":"c8148daf","917":"ff7df196","962":"6058d8af","966":"af45b725"}[chunkId] + ".css";
};